import { VisuallyHidden } from '@reach/visually-hidden'
import PropTypes from 'prop-types'
import { forwardRef } from 'react'
import { FormattedMessage } from 'react-intl'

const Hamburger = forwardRef(({ onClick, isShowing }, ref ) => (
  <button
    aria-expanded={isShowing}
    className='dropdown-toggle btn btn-none'
    data-action='Toggle'
    data-testid='mobile-menu-toggle'
    id='mobile-menu-dropdown'
    onClick={onClick}
    ref={ref}
  >
    <VisuallyHidden>
      <FormattedMessage id='header.menu' />
    </VisuallyHidden>
    <i className='mobile-menu__hamburger'>
      <span className='mobile-menu__hamburger__line' />
      <span className='mobile-menu__hamburger__line' />
      <span className='mobile-menu__hamburger__line' />
    </i>
  </button>
))

export default Hamburger

Hamburger.propTypes = {
  isShowing: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
}
